__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "claimsMfeDeliverySolutions";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "15.2.10", () => (__webpack_require__.e("node_modules_pnpm_angular_common_15_2_10__angular_core_15_2_10_rxjs_7_8_0_zone_js_0_11_8__rxj-9afa551").then(() => (() => (__webpack_require__(/*! ./node_modules/.pnpm/@angular+common@15.2.10_@angular+core@15.2.10_rxjs@7.8.0_zone.js@0.11.8__rxjs@7.8.0/node_modules/@angular/common/fesm2020/http.mjs */ 35498))))));
			register("@angular/common", "15.2.10", () => (__webpack_require__.e("node_modules_pnpm_angular_common_15_2_10__angular_core_15_2_10_rxjs_7_8_0_zone_js_0_11_8__rxj-cf88050").then(() => (() => (__webpack_require__(/*! ./node_modules/.pnpm/@angular+common@15.2.10_@angular+core@15.2.10_rxjs@7.8.0_zone.js@0.11.8__rxjs@7.8.0/node_modules/@angular/common/fesm2020/common.mjs */ 60315))))));
			register("@angular/core", "15.2.10", () => (__webpack_require__.e("node_modules_pnpm_angular_core_15_2_10_rxjs_7_8_0_zone_js_0_11_8_node_modules_angular_core_fe-7d62cf").then(() => (() => (__webpack_require__(/*! ./node_modules/.pnpm/@angular+core@15.2.10_rxjs@7.8.0_zone.js@0.11.8/node_modules/@angular/core/fesm2020/core.mjs */ 29994))))));
			register("@angular/router", "15.2.10", () => (__webpack_require__.e("node_modules_pnpm_angular_router_15_2_10__angular_common_15_2_10__angular_core_15_2_10_rxjs_7-b01e111").then(() => (() => (__webpack_require__(/*! ./node_modules/.pnpm/@angular+router@15.2.10_@angular+common@15.2.10_@angular+core@15.2.10_rxjs@7.8.0_zone.j_11b9ee35067cc35f75a8a561ab253518/node_modules/@angular/router/fesm2020/router.mjs */ 75192))))));
			register("rxjs/operators", "7.8.0", () => (__webpack_require__.e("node_modules_pnpm_rxjs_7_8_0_node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! ./node_modules/.pnpm/rxjs@7.8.0/node_modules/rxjs/dist/esm/operators/index.js */ 3891))))));
			register("rxjs", "7.8.0", () => (__webpack_require__.e("node_modules_pnpm_rxjs_7_8_0_node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! ./node_modules/.pnpm/rxjs@7.8.0/node_modules/rxjs/dist/esm/index.js */ 63660))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};